import BaseService from './base-service';

export default class MaintenanceService extends BaseService {
    constructor() {
        super('maintenance');
    }

    __getRealizedUri() {
        return `${this.url}/realized`;
    }

    listRealizedByStatus(status) {
        return this.__get(this.__injectQueryParams(this.__getRealizedUri(), {status}));
    }

    // UpdateRealizedMaintenanceDto
    updateRealized(data) {
        return this.__put(`${this.__getRealizedUri()}/${data.id}`, data);
    }

    // CompleteMaintenanceDto
    completeRealized(data) {
        return this.__post(`${this.__getRealizedUri()}/${data.id}`, data);
    }
}
